import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';

import { CamRoutes } from '@camelot/menu';

import { CamPermissionsService } from '../services/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  public readonly _permissionsService = inject(CamPermissionsService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!this._permissionsService.received) {
      return this._permissionsService.updated$.pipe(
        map(() => {
          if (this._permissionsService.isAuthenticated) {
            return true;
          } else {
            this.setRedirect(state.url);
            return false;
          }
        })
      );
    }
    if (this._permissionsService.isAuthenticated === false) {
      this.setRedirect(state.url);
      return false;
    }
    return this._permissionsService.isAuthenticated;
  }

  public setRedirect(targetUrl?: string): void {
    this.router.navigate([CamRoutes.getLogin()], targetUrl ? { queryParams: { redirectTo: targetUrl } } : undefined);
  }
}
